/**
 * PANJAB DRIP — Official Shopify Theme JavaScript
 * Countdown Timer, Design Carousel, VIP Pass Handling
 */

(function () {
  'use strict';

  // 1. COUNTDOWN TIMER
  function initCountdown() {
    const timerGrid = document.querySelector('[data-countdown-grid]');
    if (!timerGrid) return;

    const targetDateStr = timerGrid.getAttribute('data-launch-date') || '2026-10-01T00:00:00+05:30';
    const targetDate = new Date(targetDateStr).getTime();

    const daysEl = timerGrid.querySelector('[data-countdown-days]');
    const hoursEl = timerGrid.querySelector('[data-countdown-hours]');
    const minutesEl = timerGrid.querySelector('[data-countdown-minutes]');
    const secondsEl = timerGrid.querySelector('[data-countdown-seconds]');

    function update() {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
  }

  // 2. DESIGN CAROUSEL
  function initCarousel() {
    const section = document.querySelector('[data-carousel-section]');
    if (!section) return;

    const viewport = section.querySelector('[data-carousel-viewport]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');

    if (!viewport) return;

    const scrollAmount = 360;

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  }

  // 2b. HERO PRODUCT CAROUSEL
  function initHeroCarousel() {
    const carousel = document.querySelector('[data-hero-carousel]');
    if (!carousel) return;
    const slides = Array.from(carousel.querySelectorAll('[data-hero-carousel-slide]'));
    const previous = carousel.querySelector('[data-hero-carousel-prev]');
    const next = carousel.querySelector('[data-hero-carousel-next]');
    const current = carousel.querySelector('[data-hero-carousel-current]');
    const total = carousel.querySelector('[data-hero-carousel-total]');
    if (slides.length < 2) return;

    let active = 0;
    let timer;
    if (total) total.textContent = String(slides.length).padStart(2, '0');
    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        const isActive = slideIndex === active;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      if (current) current.textContent = String(active + 1).padStart(2, '0');
    }
    function stop() { window.clearInterval(timer); }
    function start() {
      stop();
      timer = window.setInterval(function () { show(active + 1); }, 3000);
    }
    if (previous) previous.addEventListener('click', function () { show(active - 1); start(); });
    if (next) next.addEventListener('click', function () { show(active + 1); start(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  // 3. MOBILE SITE NAVIGATION
  function initMobileNavigation() {
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const navigation = document.querySelector('[data-header-nav]');
    if (!toggle || !navigation) return;

    function closeNavigation() {
      navigation.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      const isOpen = navigation.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });

    navigation.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNavigation);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeNavigation();
    });
  }

  // 4. PRE-ORDER FORM & VIP PASS
  function initPreorder() {
    const form = document.querySelector('[data-preorder-form]');
    const emailInput = document.querySelector('[data-preorder-email]');
    const regionSelect = document.querySelector('[data-preorder-region]');
    const ticketEmail = document.querySelector('[data-ticket-email]');
    const ticketRegion = document.querySelector('[data-ticket-region]');

    if (emailInput && ticketEmail) {
      emailInput.addEventListener('input', function () {
        ticketEmail.textContent = emailInput.value.trim() || 'collector@panjabdrip.com';
      });
    }

    if (regionSelect && ticketRegion) {
      regionSelect.addEventListener('change', function () {
        ticketRegion.textContent = regionSelect.value || 'MAJHA // MALWA // DOABA';
      });
    }
  }

  function formatMoney(cents, format) {
    const amount = (Number(cents) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (format || 'Rs. {{amount}}').replace(/\{\{\s*amount(?:_with_comma_separator|_no_decimals)?\s*\}\}/, amount);
  }

  function initProductPage() {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;

    const variantsNode = document.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const variantId = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const status = root.querySelector('[data-variant-status]');
    const optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));

    function selectedOptions() {
      return Array.from(root.querySelectorAll('[data-option-group]')).map(function (group) {
        const checked = group.querySelector('[data-option-input]:checked');
        return checked ? checked.value : group.querySelector('.product-option-single').textContent.trim();
      });
    }

    function updateVariant() {
      if (!variants.length || !optionInputs.length) return;
      const selected = selectedOptions();
      const variant = variants.find(function (candidate) {
        return candidate.options.every(function (option, index) { return option === selected[index]; });
      });

      optionInputs.forEach(function (input) {
        const position = Number(input.dataset.optionPosition) - 1;
        const candidateOptions = selected.slice();
        candidateOptions[position] = input.value;
        const matching = variants.find(function (candidate) {
          return candidate.options.every(function (option, index) { return option === candidateOptions[index]; });
        });
        input.disabled = !matching || !matching.available;
        input.nextElementSibling.classList.toggle('is-unavailable', input.disabled);
      });

      if (!variant) return;
      variantId.value = variant.id;
      price.textContent = formatMoney(variant.price, root.dataset.moneyFormat);
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? root.dataset.addText : root.dataset.soldOutText;
      status.textContent = variant.available ? '' : 'This combination is sold out.';
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', updateVariant); });
    updateVariant();

    const dialog = root.querySelector('[data-gallery-dialog]');
    if (!dialog) return;
    const dialogImage = dialog.querySelector('[data-gallery-dialog-image]');
    root.querySelectorAll('[data-gallery-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        dialogImage.src = button.dataset.imageUrl;
        dialogImage.alt = button.dataset.imageAlt;
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-gallery-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  }

  function initCart() {
    const form = document.querySelector('[data-cart-form]');
    if (!form) return;
    const subtotal = form.querySelector('[data-cart-subtotal]');
    const status = form.querySelector('[data-cart-status]');

    form.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
      input.addEventListener('change', async function () {
        const quantity = Math.max(0, Number(input.value) || 0);
        const previous = input.dataset.cartPreviousQuantity;
        form.classList.add('is-updating');
        status.textContent = 'Updating cart.';
        try {
          const response = await fetch(form.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: input.dataset.cartLineKey, quantity: quantity })
          });
          const cart = await response.json();
          if (!response.ok) throw new Error('Cart update failed');
          if (quantity === 0) { window.location.reload(); return; }
          const item = cart.items.find(function (line) { return line.key === input.dataset.cartLineKey; });
          if (!item) { window.location.reload(); return; }
          input.value = item.quantity;
          input.dataset.cartPreviousQuantity = item.quantity;
          input.closest('[data-cart-line]').querySelector('[data-cart-line-price]').textContent = formatMoney(item.final_line_price, form.dataset.moneyFormat);
          subtotal.textContent = formatMoney(cart.total_price, form.dataset.moneyFormat);
          status.textContent = 'Cart updated.';
        } catch (error) {
          input.value = previous;
          status.textContent = 'Unable to update cart. Please try again.';
        } finally {
          form.classList.remove('is-updating');
        }
      });
    });
  }

  // DOM READY
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCountdown();
      initCarousel();
      initHeroCarousel();
      initMobileNavigation();
      initPreorder();
      initProductPage();
      initCart();
    });
  } else {
    initCountdown();
    initCarousel();
    initHeroCarousel();
    initMobileNavigation();
    initPreorder();
    initProductPage();
    initCart();
  }
})();
